import React, { useEffect, useState } from "react";
import styles from "./ActivityMapping.module.css";
import { Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { CustomButton } from "reusable-components/CustomButtonComponent/button";
import { getInternalK1ActivitiesData } from "./ActivityMapping.service";
import { Bars } from "react-loader-spinner";

import * as Icon from "react-bootstrap-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

/**
 * ActivityMapping Component
 */
const ActivityMapping: React.FC<any> = ({
  show,
  onHide,
  refresh,
  returnid,
  clientmasterid,
  parentreturnid,
  parentName,
  clientname,
  documentid,
  sourceidentifier,
  setinternalk1activities,
  internalk1activities
}) => {

  const [loadActivityMappings, setloadActivityMappings] = useState<boolean>(false);
  const [sliderEnabled, setSliderEnabled] = useState<boolean>(true);
  const [childActivties, setchildActivties] = useState<any[]>([]);
  const [parentActivities, setParentActivities] = useState<any[]>([])
  const [selectedChildren, setselectedChildren] = useState<{ [key: string]: { label: string, value: string } }>({});
  const [childOptions, setChildOptions] = useState<any[]>([]);

  const handleClose = () => {
    onHide();
  }

  useEffect(() => {
    getActivitiesDataForInternalK1()
  }, [internalk1activities, documentid]);

  const onChildActivityChange = (option: any, idx: number) => {
    setselectedChildren(prev => ({
      ...prev,
      [idx]: option
    }))

  };

  const upsertActivities = (
    list: any[] | undefined,
    update: { DocumentId: number; ParentReturnId?: any; Mappings: any[] },
    { merge = false } = {}
  ) => {
    const arr = Array.isArray(list) ? list : [];
    const i = arr.findIndex(x => Number(x.DocumentId) === Number(update.DocumentId));

    // normalize + dedupe
    const norm = (m: any) => ({
      ChildActivityNumber: String(m?.ChildActivityNumber),
      ChildActivityDescription: String(m?.ChildActivityDescription ?? "").trim(),
      ParentActivityNumber: String(m?.ParentActivityNumber ?? 0),
      ParentActivityDescription: String(m?.ParentActivityDescription ?? "").trim(),
    });
    const dedupe = (xs: any[]) => {
      const seen = new Set<string>();
      const out: any[] = [];
      for (const r of xs ?? []) {
        const m = norm(r);
        console.log(m)

        const key = `${m.ChildActivityNumber}:${m.ParentActivityNumber}`;
        if (!seen.has(key)) { seen.add(key); out.push(m); }
      }
      return out;
    };

    const nextMappings = dedupe(update.Mappings);

    if (i === -1) {
      // new doc
      return [...arr, { DocumentId: update.DocumentId, ParentReturnId: update.ParentReturnId, Mappings: nextMappings }];
    }

    const current = arr[i];
    const merged = merge ? dedupe([...(current.Mappings ?? []), ...nextMappings]) : nextMappings;

    // no-op check
    const sameLen = (current.Mappings?.length ?? 0) === merged.length;
    const sameMaps = sameLen && current.Mappings?.every((m: any, idx: number) => {
      const n = merged[idx];
      return (
        m.ChildActivityNumber === n.ChildActivityNumber &&
        m.ParentActivityNumber === n.ParentActivityNumber &&
        m.ChildActivityDescription === n.ChildActivityDescription &&
        m.ParentActivityDescription === n.ParentActivityDescription
      );
    });
    const sameParent = current.ParentReturnId === update.ParentReturnId;

    if (sameMaps && sameParent) return arr; // preserve referential equality

    const copy = [...arr];
    copy[i] = { ...current, ParentReturnId: update.ParentReturnId, Mappings: merged };
    return copy;
  };

  const getActivitiesDataForInternalK1 = async () => {
    setloadActivityMappings(true)
    const payload = {
      "ClientMasterId": clientmasterid,
      "DocumentId": documentid,
      "ReturnId": returnid,
      "ParentReturnId": parentreturnid,
      "SourceIdentifier": sourceidentifier
    }
    const data: any = await getInternalK1ActivitiesData(payload);

    if (data?.ParentActivities) {
      setParentActivities(data.ParentActivities);

      const prefilledParents: { [key: string]: { label: string; value: string } } = {};
      data.ParentActivities.forEach((m: any, idx: number) => {
        prefilledParents[idx] = {
          label: `${m.ActivityNumber}: ${m.ActivityDescription}`,
          value: String(m.ActivityNumber),
        };
      });
    }
    let saved: any = null;
    if (internalk1activities?.length) {
      saved = internalk1activities.find((m: any) => m.DocumentId === documentid);
    }
    if (data?.ChildActivities) {
      const prefilledChildren: { [key: string]: { label: string; value: string } } = {};
      data.ChildActivities.forEach((child: any, idx: number) => {
        prefilledChildren[idx] = {
          label: `${child.ActivityNumber}: ${child.ActivityDescription}`,
          value: String(child.ActivityNumber),
        };
      });
      setselectedChildren(prefilledChildren);

      const newOptions = data.ChildActivities.map((child: any) => ({
        label: `${child.ActivityNumber}: ${child.ActivityDescription}`,
        value: String(child.ActivityNumber),
      }));
      setChildOptions(newOptions);
      let normalized = data.ChildActivities.map((child: any) => ({
        ...child,
        ActivityDescription: `${child.ActivityDescription}`,
      }));
      // console.log(normalized)
      // if (saved?.Mappings?.length) {
      //   const updated = saved.Mappings.map((child: any) => {
      //     return {
      //       ActivityNumber: `${child.ChildActivityNumber}`,
      //       ActivityDescription: `${child.ChildActivityDescription}`,
      //       Description: `${child.ChildActivityDescription}`,
      //     };
      //   });

      //   normalized = [...updated];
      // }
      // console.log(normalized)
      
      const selectedChildren: { [key: string]: { label: string; value: string } } = {};
      normalized.forEach((m: any, idx: number) => {
        selectedChildren[idx] = {
          label: `${m.ActivityNumber}: ${m.ActivityDescription}`,
          value: String(m.ActivityNumber),
        };
      });
      setselectedChildren(selectedChildren)
      setchildActivties(normalized);

      // Pad if still less than parent count
      if (data.ChildActivities.length < data.ParentActivities.length) {
        const padded = [
          ...normalized,
          ...Array.from(
            { length: data.ParentActivities.length - normalized.length },
            (_, idx) => ({
              // labelling the number with _temp prefix to filter out new activities
              ActivityNumber: `${normalized.length + idx + 1}_temp`,
              Description: `New Activity`,
              ActivityDescription: `New Activity`,
            })
          ),
        ];
        // console.log(padded)
        setchildActivties(padded);
      } 

      }

    setloadActivityMappings(false);
  }

  const saveMapping = async () => {
    generateMappings();
    onHide();
  }

  const getOptionsForIndex = (idx: number) => {
    // blank option + "New Activity" (index-specific), then the base options
    const blankOption = { label: "", value: `empty_${idx}` };
    const newActivityOption = { label: "New Activity", value: `${idx}_temp` };
    return [blankOption, newActivityOption, ...childOptions]
  };

  const generateMappings = () => {
    // console.log(childActivties)
    // console.log(parentActivities)
    // console.log(selectedChildren)

    const mappings = parentActivities
      .map((parent, idx) => {
        const sel = selectedChildren[String(idx)];
        console.log(sel)
        if (!sel) return null; // nothing selected for this row -> skip
        if (sel.value.startsWith("empty_")) return null; // omits the row if child activity option is blank
        return {
          ChildActivityNumber: String(sel.value),
          ChildActivityDescription: sel.label === "New Activity" ? parent.ActivityDescription : sel.label.split(":").slice(1).join(":").trim(),
          ParentActivityNumber: String(parent.ActivityNumber),
          ParentActivityDescription: (parent.ActivityDescription || "").trim()
        };
      })
      .filter(Boolean);

    // anothe approach to set activities
    // not sure if this is the best way to do it though
    // edit reverthing back because this implementation has some bugs
    // console.log("current activities", internalk1activities);
    const next = upsertActivities(
      internalk1activities,
      { DocumentId: documentid, ParentReturnId: parentreturnid, Mappings: mappings },
      { merge: false } // set to true if you want to append+dedupe instead of replace
    );

    if (next !== internalk1activities) {
      setinternalk1activities(next);
      console.log("updating activities")
    }
    console.log("upserted activities", next);
  };

  return (
    <>
      <div
        className={styles.modaloverlay}
      />
      <Modal
        show={show}
        onHide={() => handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        contentClassName={styles.confirmModal}
      >
        <Modal.Header style={{ paddingBottom: 5, marginBottom: 10 }} className="flex-column">
          <Row className="w-100 mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <h4 className={styles.header}>&nbsp;Activity Mapping</h4>
              <button
                type="button"
                className={styles.closeButton}
                onClick={handleClose}
                aria-label="Close"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
            </div>
          </Row>
          <Row className="w-100 mb-1">
            <Col md={6}>
              <span style={{ marginLeft: 10, fontSize: 13 }}>
                Return Id - <strong>{returnid}</strong>
              </span>
            </Col>
            <Col md={6} className="d-flex justify-content-end align-items-center">


              <label className="me-1">Aggregate</label>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={sliderEnabled}
                  onChange={() => setSliderEnabled(!sliderEnabled)}
                  disabled={false}
                  style={{ appearance: "none" }}
                />
                <span className={`super-admin-slider super-admin-round ${false ? "disabled" : ""}`} />
              </label>
              <label className="ms-2">Activity wise</label>


              <OverlayTrigger
                placement="top"
                container={typeof document !== "undefined" ? document.body : undefined}
                popperConfig={{
                  strategy: "fixed",
                  modifiers: [
                    { name: "offset", options: { offset: [0, 10] } },
                    { name: "preventOverflow", options: { boundary: "viewport" } }
                  ],
                }}
                overlay={
                  <Tooltip id="transferTypeTooltip" className={styles.customTooltip}>
                    <div className={styles.tooltipContent}>
                      <strong>Aggregate</strong>: Combines all activities into one summarized sheet in the return.<br />
                      <strong>Activity wise</strong>: Transfers data individual activities to partner using source's activities.
                    </div>
                  </Tooltip>
                }
              >
                <span className={styles.infoIcon} aria-label="Transfer type help">
                  <Icon.InfoCircle size={18} />
                </span>
              </OverlayTrigger>

            </Col>
          </Row>

        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <div className="d-flex flex-column" style={{ height: "100%" }}>
            {
              loadActivityMappings
                ?
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000,
                  backdropFilter: 'blur(2px)'
                }}>
                  <Bars
                    height="70"
                    width="70"
                    color="var(--theme1_primary)"
                    ariaLabel="bars-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                  <h6 style={{ marginBottom: 0, marginRight: 20 }}>Loading</h6>
                </div>
                :
                <>
                  {sliderEnabled ? (
                    parentActivities.length === 0 ? (
                      <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                        <h5>{parentName} does not have activity wise data for {clientname} please use aggregate transfer</h5>
                      </div>
                    ) : (
                      <>
                        <Row className="w-100 mt-2 mb-2">
                          <Col md={5} className="text-center">
                            <h5>{parentName}</h5>
                          </Col>
                          <Col md={2}></Col>
                          <Col md={5} className="d-flex justify-content-between align-items-center">
                            <h5 className="flex-grow-1 text-center mb-0">{clientname}</h5>
                          </Col>
                        </Row>
                        <div className={styles.scrollableMappingSection}>
                          <Row className="no-gutter">
                            {Array.from({ length: parentActivities.length }).map((_, idx) => (
                              <React.Fragment key={idx}>
                                <Col md={5} className="d-flex justify-content-center align-items-center mb-3">
                                  {parentActivities[idx] ? (
                                    <Form.Control
                                      value={`${parentActivities[idx].ActivityNumber}: ${parentActivities[idx].ActivityDescription}`}
                                      className={styles.staticTextBoxStyle}
                                      placeholder="Activity Number: Activity Description"
                                      aria-label={`Parent activity ${idx + 1}`}
                                      readOnly
                                    />
                                  ) : null}
                                </Col>
                                <Col md={2} className="d-flex justify-content-center align-items-center mb-3">
                                  <Icon.ArrowBarRight style={{ fontSize: 25, opacity: 0.6 }} />
                                </Col>
                                <Col md={5} className="d-flex justify-content-center align-items-center mb-3">
                                  {childActivties[idx] ? (
                                    <>
                                      <Select
                                        onChange={(option: any) => onChildActivityChange(option, idx)}
                                        value={
                                          selectedChildren[idx] || null
                                        }
                                        options={getOptionsForIndex(idx)}
                                        className={styles.dropdownStyle}
                                        placeholder="Select child activity"
                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                        menuPlacement="auto"
                                        styles={{
                                          menuPortal: (base: any) => ({ ...base, zIndex: 11000 }),
                                          menu: (base: any) => ({ ...base, zIndex: 11000 }),
                                          menuList: (base: any) => ({ ...base, overflowY: 'auto', zIndex: 11000 }),
                                          option: (base: any, state: any) => ({
                                            ...base,
                                            backgroundColor: state.isSelected
                                              ? '#DEEBFF'             // selected item color (you can change)
                                              : state.isFocused
                                                ? '#DEEBFF'             // hover/focus color
                                                : 'transparent',              // normal background
                                            color: state.isSelected ? 'inherit' : 'inherit',
                                            cursor: 'pointer',
                                            minHeight: 30
                                          }),
                                           
                                        }}
                                        menuShouldBlockScroll={true}
                                      />
                                    </>
                                  ) : null}
                                </Col>
                              </React.Fragment>
                            ))}

                          </Row>
                        </div>
                      </>
                    )
                  ) : (
                    <>
                      <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                        <h4>Activity mappings not required for Aggregate Data</h4>
                      </div>
                    </>
                  )}
                </>
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col md={12}>
              <div className={`d-flex justify-content-end`}>
                <CustomButton
                  progress={false}
                  onclick={() => saveMapping()}
                  content={"Save"}
                  disable={false}
                />
              </div>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ActivityMapping;